import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { Common } from 'src/app/common';
import { MasterService } from 'src/app/shared/services/master.service';
import { forkJoin, Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-comp-off-mngmnt',
  templateUrl: './comp-off-mngmnt.component.html',
  styleUrls: ['./comp-off-mngmnt.component.css']
})
export class CompOffMngmntComponent implements OnInit {
  compOffForm: FormGroup;
  from_date: any = new Date();
  to_date: any = new Date();
  max_date = new Date();
  assessementlist = [];
  minDate: Date; minToDate: Date; docId = '';
  submitted = false; userNames = [];
  userList: Array<any> = [];
  pipe = new DatePipe('en-US');
  showExport: boolean = true;
  fileName = 'Leave Approval Rejection';
  excelData: any = [];
  dtRender: boolean = true;
  dtOptions: any = {};
  lstGrid: any = [];
  updatedData: any = [];
  statusList: any = [];
  CurpageNumber: any = 0;
  NextpageNumber: any = 0;
  PrevpageNumber: any = 0;
  totalElements: any = 0;
  rowIndex: any = 0;
  pageSize: any = 10
  search_string: any = '';
  constructor(private regService: RegistrationService
    , protected toastr: ToastrService
    , private formBuilder: FormBuilder
    , private datePipe: DatePipe
    , private excelDownloadService: ExcelDownloadService
    , private masterService: MasterService
    , private authSvc: AuthenticationService
    , public changeDetection: ChangeDetectorRef
    , private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      dom: 'Bfrtip',
      processing: true,
      buttons: [
        {
          extend: 'excelHtml5',
          title: 'Assets Report_list',
          exportOptions: { columns: ':visible:not(:first-child)' }
        },
      ]

    };
    this.initFormControls(),
      this.LoadData(0); this.LoadStatus();
    // Common.loadDataTable(this.assessementlist, '#assessementReport');
  }

  initFormControls() {
    this.compOffForm = this.formBuilder.group({
      from_date: [new Date(), Validators.required],
      to_date: [new Date(), Validators.required],
      status: ['', Validators.required]
    });
  }

  get f() { return this.compOffForm.controls; }

  LoadStatus() {
    this.regService.get(`masters/getallstatustyes`).subscribe(res => {
      if (res.status == 'OK') {
        if (res.data == null || res.data == '' || res.data == undefined)
          this.toastr.info(res.message)
        else {
          this.statusList = res.data;
        }
      }
      else {
        this.toastr.error(res.message)
      }
    })
  }


  LoadData(item: any) {
    this.dtRender = false;
    this.lstGrid = [];
    let payload = {
      "from_date": this.datePipe.transform(this.compOffForm.value.from_date, 'yyyy-MM-dd'),
      "to_date": this.datePipe.transform(this.compOffForm.value.to_date, 'yyyy-MM-dd'),
      "user_id": sessionStorage.loginId,
      "status_id": this.compOffForm.value.status || -1,
      "searchString": this.search_string,
      "page": item,
      "size": this.pageSize,
    }
    this.regService.post(`mvu/compoff/getallcompofflist`, payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          if (res.data?.content.length > 0) {
            this.totalElements = res['data']['totalElements'];
            this.lstGrid = res.data?.content;
            this.spinner.hide();
            if ((res.data["totalPages"] == 1) || (this.lstGrid.length <= this.pageSize && res.data["totalPages"] == this.NextpageNumber + 1)) {
              this.CurpageNumber = res.data["number"];
              this.NextpageNumber = 0;
              if (res.data.last == false) {
                this.NextpageNumber = res.data["number"] + 1;
              }
              this.PrevpageNumber = res.data["number"] - 1;

            } else {
              this.CurpageNumber = res.data["number"];
              this.NextpageNumber = res.data["number"] + 1;
              this.PrevpageNumber = res.data["number"] - 1;
              this.rowIndex = 0;
              this.spinner.hide();
            }
            this.rowIndex = this.CurpageNumber * this.pageSize;
          }
          else {
            this.toastr.warning("No records found");
            this.CurpageNumber = 0;
            this.NextpageNumber = 0;
            this.PrevpageNumber = 0;
            this.totalElements = 0;
            this.lstGrid = [];
            this.spinner.hide();
          }
        } else {
          this.lstGrid = [];
          this.toastr.warning(res.message);
          this.CurpageNumber = 0;
          this.NextpageNumber = 0;
          this.PrevpageNumber = 0;
          this.totalElements = 0;
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
      },
      complete: () => {
      },
    });

    // this.regService.post(`mvu/empappliedleaves/getall`, payload).subscribe(res => {
    //   if (res.status == 'OK') {
    //     if (res.data == null || res.data == '' || res.data == undefined)
    //       this.toastr.info(res.message)
    //     else {
    //       this.lstGrid = res.data;
    //       this.toastr.success(res.message);
    //       this.dtRender = true;
    //     }
    //   }
    //   else {
    //     this.toastr.error(res.message)
    //   }
    // })
  }
  downLoadListExcel() {
    let payload = {
      "from_date": this.datePipe.transform(this.compOffForm.value.from_date, 'yyyy-MM-dd'),
      "to_date": this.datePipe.transform(this.compOffForm.value.to_date, 'yyyy-MM-dd'),
      "user_id": sessionStorage.loginId,
      "status_id": this.compOffForm.value.status || -1,
      "searchString": this.search_string,
      "page": 0,
      "size": this.pageSize,
    }
    this.regService.post(`mvu/compoff/getallcompofflist`, payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          if (res.data.content.length > 0) {
            this.totalElements = res['data']['totalElements'];
            this.excelData = res.data.content;
            const fileName = 'Employee Approval Rejection list'
            var excelData = this.excelData;
            excelData = excelData.map(item => ({
              ...item,
              status:
                item.status === 1
                  ? 'Pending'
                  : item.status === 2
                    ? 'Approved'
                    : item.status === 3
                      ? 'Rejected'
                      : 'Unknown',
            }));

            if (excelData.length > 0) {
              const excelHeaders = [
                'Employee Name', 'Duration', 'Comp Off Date', 'Applied On', 'Approved/Rejected By', 'Action Date', 'status',
              ];
              const internalHeaders = [
                'user_name', 'duration', 'comp_off_date', 'created_on', 'approved_by_name', 'approved_date', 'status',
              ];

              this.toastr.success('Please wait excel is downloading')
              this.excelDownloadService.downloadExcel(excelHeaders, internalHeaders, fileName, excelData)
            }
          }
        }
      }
    });
  }


  updateData(item: any, number: any) {
    let payload = {
      "status": number,
      "id": item?.id,
      "approved_by": sessionStorage.loginId,

    }
    this.regService.post(`mvu/compoff/save`, payload).subscribe((res) => {
      if (res.status == 'OK') {
        if (res.data == '' || res.data == null || res.data == undefined) {
          this.toastr.info(res.message)
        }
        else {
          this.updatedData = res.data;
          this.LoadData(0);
          this.toastr.success(res.message)
        }
      } else {
        this.toastr.error(res.message)
      }
    })
  }

  clear() {
    this.initFormControls();
    // Common.loadDataTable(this.assessementlist, '#assessementReport');
  }
  exportexcel(): void {

    var table = $('#assessementReport').DataTable();

    if (!table.data().count()) {
      this.toastr.error('No data available in table! Please select and try again');
    }
    else {
      / table id is passed over here /
      let element = document.getElementById('assessementReport');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);


      / generate workbook and add the worksheet /
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      ws['!cols'] = [];
      ws['!cols'][10] = { hidden: true };


      / save to file /
      XLSX.writeFile(wb, this.fileName);
    }
  }
  downLoadExcel() {
    const fileName = this.fileName;
    var excelData = this.excelData;
    if (excelData.length > 0) {
      excelData.map(res => {
        res.formated_created_on = this.pipe.transform(res.created_on, 'dd-MM-yyyy');
      })
      const excelHeaders = ['Health Care Worker Name', 'Health Care Worker Type', 'Created On', 'Equipment Name', 'Remarks', 'verification', 'Status'];
      const internalHeaders = ['user_name', 'center_type', 'formated_created_on', 'assessment_name', 'remarks', 'verified', 'working_status'];
      this.toastr.success('Please wait excel is downloading')
      this.excelDownloadService.downloadExcel(excelHeaders, internalHeaders, fileName, excelData)
    }
    else {
      this.toastr.error('No data to download')
    }

  }
}



